import {
  Input as ChakraInput,
  type InputProps as ChakraInputProps,
} from '@chakra-ui/react';

import type { InputState } from '@burnsred/entity-form';

import { GenericInput } from '@/forms/components/GenericInput';

export const InputWidget = (props: InputState & ChakraInputProps) => (
  <GenericInput<ChakraInputProps>
    className="InputWidget"
    Component={ChakraInput}
    {...props}
  />
);
